{
  "version": 1,
  "asset_id": "32fcb1dd-df58-4a33-a36b-76e311daac0c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/32fcb1dd-df58-4a33-a36b-76e311daac0c/hiatal-type-iv-patient-before-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/32fcb1dd-df58-4a33-a36b-76e311daac0c/hiatal-type-iv-patient-before-es-480.webp",
  "original_filename": "hiatal-type-iv-patient-before-es-480.webp",
  "size": 27882,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:51Z"
}
